/**
 * Analytics utility functions
 */

// UUID v4 regex pattern
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Check if a path is an event page path
 */
export const isEventPath = (path: string): boolean => {
  const match = path.match(/^\/events\/(.+)$/);
  if (!match) return false;
  return UUID_PATTERN.test(match[1]);
};

/**
 * Extract event ID from an event page path
 * Returns null if path is not an event path
 */
export const extractEventIdFromPath = (path: string): string | null => {
  const match = path.match(/^\/events\/([0-9a-f-]+)$/i);
  if (!match) return null;
  const id = match[1];
  return UUID_PATTERN.test(id) ? id : null;
};

/**
 * Extract all unique event IDs from an array of paths
 */
export const extractEventIdsFromPaths = (paths: string[]): string[] => {
  const ids = new Set<string>();
  paths.forEach((path) => {
    const id = extractEventIdFromPath(path);
    if (id) ids.add(id);
  });
  return Array.from(ids);
};

/**
 * Format a path for display, replacing event UUIDs with titles if available
 */
export const formatPathForDisplay = (
  path: string,
  eventTitles: Record<string, string>,
  maxLength = 30
): string => {
  const eventId = extractEventIdFromPath(path);
  if (eventId && eventTitles[eventId]) {
    const title = eventTitles[eventId];
    return title.length > maxLength ? `${title.slice(0, maxLength)}...` : title;
  }
  return path.length > maxLength ? `${path.slice(0, maxLength)}...` : path;
};
